import React, { Component } from 'react';
import './App.css';

export default class FAQ extends Component {
    
    render() {

        const liste =
        [
            {
                question: "Pourquoi un site sur Internet ?",
                reponse: "Si j’étais né à l’époque de la guerre du feu, j’aurais aimé être parmi les premiers utilisateurs du feu."
            },
            {
                question: "Pourquoi certains tableaux ne sont pas signés ?",
                reponse: "Non, ils sont tous signés mais parfois au dos. Les premiers étaient signés de mon prénom comme Van Gogh, puis monogrammés comme Auguste Rodin, ensuite mon prénom et mes deux noms de famille pour faire plaisir à ma mère. Certains au dos comme les ‘‘Feuilles-Cœur’’ pour ne pas faire perdre de la force à la composition et préserver toute la tension de la ‘‘Feuille-Cœur’’ avec le cadre."
            },
            {
                question: "Qu’est-ce qui vous énerve le plus dans le système de l’Art actuel ?",
                reponse: "Les galeries incapables de prendre des risques économiques avec des jeunes Artistes, les commissaires-priseurs qui bradent des œuvres comme des légumes sans scrupules, le mélange du public entre expositions et ventes réelles, entre le réel intérêt des œuvres et les prix de vente annoncés, ceux qui fixent les prix en fonction des formats comme si c’était de la moquette, ceux qui vont très peu ou jamais voir les expos dans les galeries alors que c’est gratuit, la télé qui parle rarement des peintres contemporains, ceux qui ne font même pas la différence entre une œuvre originale et une lithographie ou même une reproduction....Bon, je vais arrêter pour aujourd’hui !..."
            },
            {
                question: "Vous faites partie des peintres présentés par l’Ambassade du Portugal à Paris, vous sentez-vous comme un porte-drapeau du Portugal ?",
                reponse: "Non. Je suis fier de mes origines portugaises mais à notre époque (Internet, télés câblées, grandes bibliothèques) les influences culturelles sont internationales et l’essence même des œuvres se place plus sur l’unicité des individus que celle d’une ville ou pays."
            },
            {
                question: "Selon vous, quel doit être le rôle des artistes dans la société ?",
                reponse: "Pour ma part, il doit être capable d’apporter sa suggestion du ‘‘beau’’ mais aussi ne pas s’enfermer dans sa bulle d’artiste et être capable d’engagements socio-politiques en toute indépendance, émerveillements et engagements !"
            },
            {
                question: "De quelles œuvres êtes-vous le plus fier ?",
                reponse: "Je serais tenté de dire « La naturelle » ma première ‘‘Feuille-Cœur’’ et mes portraits contre le racisme, mais en fait, chaque peinture ou dessin, même le plus anodin, joue son rôle dans le cheminement de l’œuvre... "
            },
            {
                question: "Quels sont vos peintres préférés ?",
                reponse: "Les peintres préhistoriques, les dessins d’enfants et Picasso (pour son œuvre et sa vie) même si ce n’est pas original..."
            },
            {
                question: "Quels sont les peintres qui vous ont le plus influencé ?",
                reponse: "Il y en a beaucoup mais de façon indirecte."
            },
            {
                question: "Comment expliquez-vous la minorité de personnes qui s’intéressent réellement à l’Art ?",
                reponse: "Je crois que beaucoup n’ont pas compris qu’une peinture est avant tout un langage singulier avant d’être un objet décoratif."
            },
            {
                question: "Combien de temps passez-vous pour réaliser un tableau ?",
                reponse: "Rarement plus d’une journée pour le faire mais le temps de gestation de celui-ci est impossible à calculer, parfois des années, c’est du domaine de l’inconscient qui travaille tout le temps."
            },
            {
                question: "Est-il difficile d’être artiste-peintre à notre époque ?",
                reponse: " A partir du moment où l’on fait une activité proche de sa vocation et de son envie ou de son rêve, il n’y a pas de métier difficile. Forcément, ceux qui ont du talent apprendront plus vite."
            },
            {
                question: "Quels conseils donneriez-vous à un jeune artiste ?",
                reponse: "Ne jamais se décourager tout en sachant que la peinture est un marathon qui dure toute une vie sans peut-être ne jamais avoir de reconnaissance artistique et économique. Connaître un minimum de l’Histoire de l’Art mondial, de la préhistoire à nos jours, sans en subir d’influences directes. Peindre ce qu’il aime au moment où il peint. Eviter les recettes répétitives. Se donner des espaces - temps de respirations. Considérer l’Art comme une aventure, pas comme un métier au sens du fonctionnaire qui en attend un salaire régulier..."
            },
            {
                question: "Que pensez-vous des différences de prix des œuvres en général ?",
                reponse: "Il n’y a pas vraiment de logique pour les prix, certaines œuvres sont surestimées simplement pour valoriser une collection privée ou d’un pays. C’est ainsi que l’on peut voir des œuvres contemporaines vendues plus chères que des pièces antiques. Heureusement la logique des tableaux vendus plus chers après la mort de l’artiste n’est pas toujours vérifiée. Il n’y a pas d’œuvres commerciales, c’est une histoire d’offre et de demande selon les lieux de ventes."
            },
            {
                question: "Etes-vous un peintre écologiste ?",
                reponse: "Mes ‘‘Feuilles-Cœur’’ symbolisent la nature et une sensibilité pour l’écologie mais je ne me sens pas militant dans l’âme, cela me préoccupe comme le racisme et les droits de l’Homme. "
            },
            {
                question: "Vous êtes-vous réellement coupé une mèche de cheveux pour fabriquer un pinceau à l’école à l’âge de 8 ans ?",
                reponse: "Oui, c’était peut-être un signe mais je me souviens d’avoir trouvé cette astuce pour ne pas me faire engueuler par le prof parce que j’avais oublié mon matériel. Autant l’enseignement était trop strict dans ces années-là, autant il y a trop de laxisme actuellement... "
            },
            {
                question: "Quelles doivent être les principales qualités d’un tableau selon vous ?",
                reponse: "Être original, suciter l'émerveillement, témoigner de son époque, sans souci de la censure politique et économique."
            },
            {
                question: "Avez-vous mis toute votre production sur le site Internet ?",
                reponse: "Non, il y a des peintures, surtout du début, qui n’ont pas été prises en photo. Il y a quand même les principaux tableaux clés des différents thèmes ou techniques..."
            }
        ];

        const listItem = liste.map((item) => 
        <div>
            <div class="card">
            <div class="card-header">
            {item.question}
            </div>
            <div class="card-body">
              <blockquote class="blockquote mb-0">
                <p>« {item.reponse} ».</p>
              </blockquote>
            </div>
          </div>
          <br />
          </div>
          );

    return (
        <div>
        <div className="titre">Interview</div>
        <p class="presentation">Jorge Sancho Galego répond à vos questions</p>
        <div>
        {listItem}
        </div>

        <small>Questionnaire réalisé à partir des interrogations qui reviennent le plus souvent chez les personnes qui sont intéressées par mon travail.(février 2001)</small>
        </div>
    );
}
}



// WEBPACK FOOTER //
// ./src/FAQ.js